import { Permission } from '../../pages/roles/permission';

const CASH_SHIFT_PERMISSION = 'CashShift';

export function findCashShiftPermission(permissions: Permission[] | undefined): Permission | undefined {
  return permissions?.find((permission) => permission.name === CASH_SHIFT_PERMISSION);
}

export function hasCashShiftAccess(permissions: Permission[] | undefined): boolean {
  return !!findCashShiftPermission(permissions);
}

export function hasCashShiftCanAdd(permissions: Permission[] | undefined): boolean {
  const permission = findCashShiftPermission(permissions);
  return !!permission?.canAdd;
}

export function hasCashShiftCanEdit(permissions: Permission[] | undefined): boolean {
  const permission = findCashShiftPermission(permissions);
  return !!permission?.canEdit;
}

const FLOOR_PLAN_PERMISSION = 'FloorPlan';

export function findFloorPlanPermission(permissions: Permission[] | undefined): Permission | undefined {
  return permissions?.find((permission) => permission.name === FLOOR_PLAN_PERMISSION);
}

export function hasFloorPlanAccess(permissions: Permission[] | undefined): boolean {
  return !!findFloorPlanPermission(permissions);
}

export function hasFloorPlanCanAdd(permissions: Permission[] | undefined): boolean {
  const permission = findFloorPlanPermission(permissions);
  return !!permission?.canAdd;
}

export function hasFloorPlanCanEdit(permissions: Permission[] | undefined): boolean {
  const permission = findFloorPlanPermission(permissions);
  return !!permission?.canEdit;
}

const CASH_EXPENSE_PERMISSION = 'CashExpense';

export function findCashExpensePermission(permissions: Permission[] | undefined): Permission | undefined {
  return permissions?.find((permission) => permission.name === CASH_EXPENSE_PERMISSION);
}

export function hasCashExpenseAccess(permissions: Permission[] | undefined): boolean {
  return !!findCashExpensePermission(permissions);
}

export function hasCashExpenseCanAdd(permissions: Permission[] | undefined): boolean {
  const permission = findCashExpensePermission(permissions);
  return !!permission?.canAdd;
}

export function hasCashExpenseCanEdit(permissions: Permission[] | undefined): boolean {
  const permission = findCashExpensePermission(permissions);
  return !!permission?.canEdit;
}
